export const errorsMessages = {
  'generic_error': 'Se ha producido un error. Inténtalo más tarde y si el problema persiste ponte en contacto con soporte.',
  'user_or_password_not_valid': 'Usuario o contraseña no válidos',
  'not_valid_data': 'Datos no válidos',
  'cant_create_user_by_non_unique_email': 'No se puede crear un usuario con un email que ya existe.',
  'not_enough_permissions': '',
  'key_not_found': '',
  'userId_not_found': '',
  'product_not_found': '',
  'user_course_not_completed': '',
  'payment_platform_not_supported': '',
  'redsys_invalid_signature': '',
  'cant_create_article_category': '',
  'cant_create_article': '',
  'cant_update_article': '',
  'cant_remove_article': '',
  'cant_create_article_tag': '',
  'cant_update_article_tag': '',
  'cant_remove_article_tag': '',
  'cant_update_config': '',
  'cant_remove_config': '',
  'cant_create_config': '',
  'cant_create_product_image': '',
  'cant_update_product_image': '',
  'cant_remove_product_image': '',
  'cant_create_conversation_message': '',
  'cant_create_conversation_by_non_unique_key': '',
  'cant_create_conversation': '',
  'cant_update_conversation': '',
  'cant_create_delivery_method_by_non_unique_type': '',
  'cant_create_delivery_method': '',
  'cant_update_delivery_method': '',
  'cant_remove_delivery_method': '',
  'cant_create_email_template_by_non_unique_type': '',
  'cant_create_email_template': '',
  'cant_update_email_template': '',
  'cant_remove_email_template': '',
  'cant_create_loan_by_non_unique_type': '',
  'cant_create_loan': '',
  'cant_update_loan': '',
  'cant_remove_loan': '',
  'cant_create_menu': '',
  'cant_update_menu': '',
  'cant_remove_menu': '',
  'cant_create_offer': '',
  'cant_update_offer': '',
  'cant_remove_offer': '',
  'cant_create_order_anon': '',
  'cant_create_order_item': '',
  'cant_update_order_item': '',
  'cant_remove_order_item': '',
  'cant_create_order': '',
  'cant_update_order': '',
  'cant_remove_order': '',
  'cant_get_user_valid_orders': '',
  'cant_get_orders': '',
  'cant_create_page': '',
  'cant_update_page': '',
  'cant_remove_page': '',
  'cant_create_payment_method_by_non_unique_type': '',
  'cant_create_product_block': '',
  'cant_update_product_block': '',
  'cant_remove_product_block': '',
  'cant_create_product_category': '',
  'cant_update_product_category': '',
  'cant_remove_product_category': '',
  'cant_create_field_group': '',
  'cant_update_field_group': '',
  'cant_remove_field_group': '',
  'cant_create_product_price': '',
  'cant_update_product_price': '',
  'cant_list_product_price_profiles': '',
  'cant_remove_product_price': '',
  'cant_create_product': '',
  'cant_update_product': '',
  'cant_remove_product': '',
  'cant_create_product_variant': '',
  'cant_update_product_variant': '',
  'cant_remove_product_variant': '',
  'cant_create_shop': '',
  'cant_update_shop': '',
  'cant_remove_shop': '',
  'cant_create_tax': '',
  'cant_update_tax': '',
  'cant_remove_tax': '',
  'cant_create_user_course': '',
  'cant_update_user_course': '',
  'cant_remove_user_course': '',
  'cant_create_user': '',
  'cant_update_user_by_non_unique_email': '',
  'cant_update_user': '',
  'cant_remove_user': '',
  'article_category_not_found': '',
  'article_tag_not_found': '',
  'article_not_found': '',
  'tag_not_found': '',
  'config_not_found': '',
  'contact_not_found': '',
  'not_enough_conversation_permissions': '',
  'conversation_not_found': '',
  'conversation_not_owned': '',
  'cant_calculate_courier_amount': '',
  'tax_not_found': '',
  'delivery_method_not_found': '',
  'email_template_already_exists': '',
  'email_template_not_found': '',
  'email_template_with_type_already_exists': '',
  'file_format_not_supported': '',
  'order_not_found': '',
  'order_not_found_by_payment_intent': '',
  'order_not_found_by_order_id': '',
  'loan_not_found': '',
  'loan_can_be_set_as_default': '',
  'product_category_not_found': '',
  'menu_item_max_depth_exceeded': '',
  'menu_not_found': '',
  'offer_not_found': '',
  'payment_method_not_available': '',
  'order_delivery_method_not_supported': '',
  'pickup_location_not_found': '',
  'pickup_location_not_accepting_pickup_orders': '',
  'email_already_registered_by_another_user': '',
  'product_variant_not_found': '',
  'order_has_products_cant_buy_more_units': '',
  'cant_pay_order_try_later': '',
  'refund_amount_too_high': '',
  'invalid_order_status': '',
  'invalid_new_order_status': '',
  'page_slug_is_reserved': '',
  'page_with_slug_already_exists': '',
  'page_not_found': '',
  'user_not_in_payment_platform': '',
  'cant_find_user_payment_method': '',
  'cant_assign_customer_payment_method': '',
  'user_already_created_in_payment_platform': '',
  'user_cant_be_created_in_payment_platform': '',
  'customer_not_found': '',
  'tokenization_payment_gateway_not_supported': '',
  'cant_tokenize_customer_payment_method': '',
  'method_not_found': '',
  'payment_method_not_found': '',
  'product_field_group_not_found': '',
  'product_tag_not_found': '',
  'parent_not_found': '',
  'product_block_not_found': '',
  'product_category_max_depth_exceeded': '',
  'category_not_found': '',
  'product_category_parent_id_target_self': '',
  'product_field_group_is_used': '',
  'product_image_not_found': '',
  'product_price_already_exist': '',
  'product_price_not_found': '',
  'shop_not_found': '',
  'token_used_or_invalid': '',
  'token_expired': '',
  'user_not_found': '',
  'email_not_valid': '',
  'user_login_not_allowed': '',
  'course_not_found': '',
  'authorization_required': '',
  'user_course_not_found': '',
  'course_block_not_found': '',
  'wishlist_not_found': ''
}
